<template>
  <v-layout row justify-space-between>
    <v-flex xs10 offset-xs1 ref="funnelWrapper">
      <vue-funnel-graph :width="selectedFunnelLayout.width"
                        :height="selectedFunnelLayout.height"
                        :labels="funnel.milestones"
                        :values="funnel.values"
                        :colors="funnel.colors"
                        :sub-labels="funnel.groups"
                        :direction="selectedFunnelLayout.direction"
                        :gradient-direction="selectedFunnelLayout.gradientDirection"
                        :animated="true"
                        :display-percentage="true"/>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js'

export default {
  name: 'ActivitiesOverviewFunnel',
  components: {
    VueFunnelGraph
  },
  mounted () {
    // Modify layouts width according to the current wrapper width
    this.funnel.settings[0].width = this.$refs.funnelWrapper.clientWidth
    this.funnel.settings[1].width = this.$refs.funnelWrapper.clientWidth - 136
  },
  data () {
    return {
      dateRange: {
        format: 'YYYY-MM-DD',
        options: ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Custom...'],
        defaultOption: 'Last 30 days',
        value: {}
      },
      activities: {
        pagination: {
          descending: false,
          rowsPerPage: -1,
          page: 1,
          totalItems: 0,
          sortBy: 'username'
        },
        items: [1],
        loading: false
      },
      /**
       * DO NOT CHANGE THE DEFAULT LAYOUT
       * the vue-funnel-graph-js library has a bug if the initial layout direction value set to vertical
       */
      funnel: {
        milestones: [
          'Credentials created/updated',
          'Login authentication successfully',
          'Game Tutorial completed',
          'Game Task n completed',
          'Game assessment completed',
          'Users assessment ready for scoring',
          'Users assessment scored',
          'ATS confirms successful receipt of user score'
        ],
        groups: ['Brazil DC', 'UK DC', 'US DC'],
        // Each array represents a milestone groups numbers
        values: [
          [50000, 25000, 10000],
          [45000, 24000, 9000],
          [40000, 23000, 8000],
          [35000, 22000, 7000],
          [30000, 21000, 6000],
          [25000, 20000, 5000],
          [20000, 19000, 4000],
          [15000, 18000, 3000]
        ],
        // Groups colors
        colors: [
          ['#FFB178', '#FF3C8E'],
          ['#A0BBFF', '#EC77FF'],
          ['#A0F9FF', '#7795FF']
        ],
        // The selected layout
        layout: 0,
        // Layout settings
        settings: [
          {
            direction: 'horizontal',
            gradientDirection: 'horizontal',
            width: 1300,
            height: 300
          },
          {
            direction: 'vertical',
            gradientDirection: 'vertical',
            width: 1000,
            height: 800
          }
        ]
      }
    }
  },
  computed: {
    /**
     * Get the selected layout
     */
    selectedFunnelLayout () {
      return this.funnel.settings[this.funnel.layout]
    }
  }
}
</script>

<style lang="sass">
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label
  // milestone data
  .label__title
    color: #000
  .label__value,
  .label__percentage
    color: #666
  .label__segment-percentages ul li .percentage__list-label
    display: block
// Groups
.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel
  color: #333
</style>
